// @flow
import client from '../../client'
import getAuthorizedUserId from '../user/getAuthorizedUserId'
import format from '../../utils/format'

// API Endpoint
export const USER_ADD_CREDIT_CARD = '/auth/users/{0}/payment-options/'

/**
 * Add an user's credit card
 * @param  {Object} data Credit card information
 * @param  {string} [data.name] Credic card holder name
 * @param  {string} [data.address_line1] Credit card holder address
 * @param  {string} [data.address_state] Credit card holder state
 * @param  {string} [data.address_country] Credic card holder country
 * @param  {string} [data.description] Credit card description
 * @param  {Object} source Stripe credit card source object, created by Stripe client.
 * @return {Promise|Error} A resolved Promise with the credit card added or Rejected with an Error
 */
export const addCreditCard = (body: {
  paymentmethod_id: string,
  stripe_customer_id: string,
  description?: ?string,
  stripe_origin: ?string,
}): Promise<any> => {
  const userId = getAuthorizedUserId()
  const endpoint = format(USER_ADD_CREDIT_CARD, userId)
  return client.post(endpoint, { body })
}

export default addCreditCard
